export { default } from './PageAccounts.vue'
